function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#BEFFFC",
  d: "M3.762 62.84h5.522v-8.6H3.762zm9.91 0h5.522V50.2h-5.522zm9.91 0h5.522V46.161h-5.522zm9.911 0h5.522V42.382h-5.522zm9.909 0h5.522V37.821h-5.522z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M4.739 62.84h5.522v-8.6H4.739zm9.91 0h5.522V50.2h-5.522zm9.911 0h5.522V46.161H24.56zm9.91 0h5.522V42.382H34.47zm9.91 0h5.522V37.821H44.38zm15.432-.243v.244h-.245"
}), React.createElement("path", {
  d: "M58.976 62.84h-1.48",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.296,0.592,0.296,0.592"
}), React.createElement("path", {
  d: "M57.199 62.84h-2.37",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.296,0.592,0.296,0.592,0.296,0.592"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M54.534 62.84h-.244v-.243"
}), React.createElement("path", {
  d: "M54.29 61.571V59.01",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.512,1.025,0.512,1.025"
}), React.createElement("path", {
  d: "M54.29 58.497V31.341",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.512,1.025,0.512,1.025,0.512,1.025"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M54.29 30.828v-.244h.244"
}), React.createElement("path", {
  d: "M55.127 30.584h1.48",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.296,0.592,0.296,0.592"
}), React.createElement("path", {
  d: "M56.903 30.584h2.369",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.296,0.592,0.296,0.592,0.296,0.592"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M59.567 30.584h.245v.244"
}), React.createElement("path", {
  d: "M59.812 31.854v2.562",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.512,1.025,0.512,1.025"
}), React.createElement("path", {
  d: "M59.812 34.928v27.156",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.512,1.025,0.512,1.025,0.512,1.025"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M69.722 62.597v.244h-.245"
}), React.createElement("path", {
  d: "M68.886 62.84h-1.48",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.296,0.592,0.296,0.592"
}), React.createElement("path", {
  d: "M67.109 62.84h-2.37",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.296,0.592,0.296,0.592,0.296,0.592"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M64.444 62.84H64.2v-.243"
}), React.createElement("path", {
  d: "M64.2 61.657v-2.349",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.47,0.9390000000000001,0.47,0.9389999999999999"
}), React.createElement("path", {
  d: "M64.2 58.839V21.265",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.47,0.9390000000000001,0.47,0.9390000000000001,0.47,0.9389999999999999"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M64.2 20.795v-.244h.244"
}), React.createElement("path", {
  d: "M65.037 20.55h1.48",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.296,0.592,0.296,0.592"
}), React.createElement("path", {
  d: "M66.813 20.55h2.369",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.296,0.592,0.296,0.592,0.296,0.592"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M69.478 20.55h.245v.245"
}), React.createElement("path", {
  d: "M69.722 21.734v2.35",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.47,0.9390000000000001,0.47,0.9389999999999999"
}), React.createElement("path", {
  d: "M69.722 24.553v37.574",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "0.47,0.9390000000000001,0.47,0.9390000000000001,0.47,0.9389999999999999"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  d: "M.213 67.87H75.95V.003"
}), React.createElement("path", {
  d: "M7.794 48.015l9.927-5.054 9.386-4.332 9.927-1.263 9.747-5.595 9.928-5.957 9.385-11.01",
  stroke: "#28348A",
  strokeWidth: 0.4,
  strokeDasharray: "1.466,2.932,1.466,2.932,1.466,2.932"
}), React.createElement("path", {
  d: "M64.989 12.91a2.647 2.647 0 1 0 5.294 0 2.647 2.647 0 0 0-5.294 0zM78.718.184h-5.596M.183 65.072v5.595",
  stroke: "#28348A",
  strokeWidth: 0.4
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 79 71",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/historical_data.svg